import { IoMdClose } from "react-icons/io";
import "./ModalWindow.css"

const ModalWindow = ({title, buttons, closeFunction, content, width, minWidth}) => {

    if(!width){
        width = "fit-content";
    }

    return (
        <div className="modalBackground">
            <div style={{width: width, minWidth: minWidth}} className="modalWindow">
                <div className="modalHeader">
                    <p>{title}</p>
                    { closeFunction &&
                        <IoMdClose onClick={closeFunction}/>
                    }
                </div>
                <div className="modalContent">
                    {content}
                </div>
                { buttons &&
                    <div className="modalFooter">
                        { buttons.map(button => (
                            <button className={`modalButton ${button.className}`} onClick={button.onClick}>{button.Text}</button>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default ModalWindow;